import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Spinner, Switch } from "@nextui-org/react";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import ControlledInput from "../../../../components/elements/ControlledInput";
import { reportConsumptionValidation } from "../../../../services/validation";
import { getFetcher, patchFetcher } from "../../../../services/api";
import { dirtyInput, isResponseErrorObject } from "../../../../services/helpers";
import { month } from "../../../../enums/month";

export default function EditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isExistReport, setIsExistReport] = useState(true);
  const { data, isLoading } = useSWR(`/api/pelaporan-penggunaan-bahan-b3/find/${id}`, getFetcher);
  const {
    register,
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting, dirtyFields },
  } = useForm({ resolver: yupResolver(reportConsumptionValidation) });

  useEffect(() => {
    if (!isLoading && data) {
      reset({
        companyId: data?.company?.name,
        dataBahanB3Id: `${data?.dataBahanB3?.casNumber} - ${data?.dataBahanB3?.namaBahanKimia}`,
        periodId: data?.period.name,
        bulan: month[data?.bulan - 1],
        tahun: data?.tahun,
        laporanTersedia: setIsExistReport(data?.laporanTersedia),
        jumlahB3Digunakan: data?.jumlahB3Digunakan,
      });
    }
  }, [isLoading, data, reset]);

  function existReport(val) {
    setIsExistReport(val);
    setValue("jumlahB3Digunakan", undefined);
  }

  async function onSubmitForm(formData) {
    try {
      const filteredData = dirtyInput(dirtyFields, formData);
      console.log(filteredData);

      await patchFetcher(`/api/pelaporan-penggunaan-bahan-b3/edit`, data?.id, filteredData);
      navigate(-1);
      toast.success("Laporan konsumsi bahan b3 berhasil diubah!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  return (
    <RootAdmin>
      <Card radius="sm">
        <CardBody>
          <form onSubmit={handleSubmit(onSubmitForm)}>
            {!isLoading && data ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
                  <div className="col-span-2">
                    <ControlledInput control={control} label="Perusahaan" name="companyId" isRequired={true} isDisabled={true} />
                  </div>
                  <ControlledInput control={control} label="Bahan B3" name="dataBahanB3Id" isRequired={true} isDisabled={true} />
                  <ControlledInput control={control} label="Periode" name="periodId" isRequired={true} isDisabled={true} />
                  <ControlledInput control={control} label="Bulan" name="bulan" isRequired={true} isDisabled={true} />
                  <ControlledInput control={control} label="Tahun" name="tahun" isRequired={true} isDisabled={true} />
                  <div className="col-span-3 mt-3">
                    <Switch
                      {...register("laporanTersedia", {
                        onChange: (e) => {
                          existReport(e.target.checked);
                        },
                      })}
                      size="sm"
                      isSelected={isExistReport}
                    >
                      {isExistReport ? "Laporan Tersedia" : "Tidak ada laporan penggunaan"}
                    </Switch>
                  </div>
                  {isExistReport && <ControlledInput control={control} label="Jumlah Digunakan" name="jumlahB3Digunakan" type="number" isRequired={true} />}
                </div>
                <div className="flex items-center gap-2">
                  <Button color="primary" type="submit" isDisabled={isSubmitting || Object.keys(dirtyFields).length === 0} isLoading={isSubmitting}>
                    Simpan
                  </Button>
                  <Button color="warning" variant="faded" isDisabled={isSubmitting} isLoading={isSubmitting} onPress={() => navigate(-1)}>
                    Kembali
                  </Button>
                </div>
              </>
            ) : (
              <div className="flex flex-col gap-3">
                <Spinner />
              </div>
            )}
          </form>
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
